module.exports = {
	nav: {
		home: 'ホーム',						// 首页
		about: '私たちについて',					// 关于我们
		project: 'プロジェクトの実景',					// 项目实景
		contact: 'お問い合わせ',				// 联系我们
		language: '言語',			// 语言选择
	},
	content: {
		// 2021/11/12 内容区 要首字母大写
		about: '私たちについて',					// 关于我们
		contact: 'お問い合わせ',				// 联系我们
	},
	contact: {
		xing: '姓',		// 姓
		name: '名',		// 名
		email: 'メールアドレス',		// 邮箱
		address: 'アドレス',	// 住址
		zhushi: '意見',		// 意見
		submit: '提出',		// 提交
		bitian: '必須項目',		// 必填项
		
		inputXing: '请输入您的姓氏(ri)',			// 请输入您的姓氏
		inputName: '请输入您的名字(ri)',			// 请输入您的名字
		inputZqEmail: '有効なメールアドレスを入力してください',	// 请输入有效的邮箱号
		
	}
}